import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import styles from './FieldLabel.module.scss';

const FieldLabel = ({ text, size, testId }) => {
  return <label data-testid={testId} className={cn(styles.container, styles[size])}>
    {text}
  </label>;
};

FieldLabel.defaultProps = {
  size: 'small'
};

FieldLabel.propTypes = {
  text: PropTypes.string,
  size: PropTypes.oneOf(['small', 'big']),
  testId: PropTypes.string
};

export default FieldLabel;
